// extracted by mini-css-extract-plugin
export default {"googleButton":"GoogleLoginButton_googleButton__UPla0","googleIcon":"GoogleLoginButton_googleIcon__ZJAYZ"};